/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

export default (visualizationType :any, currentPlacement :any) :boolean => {

    const { requirements } = visualizationType;
    if (!requirements) {
        // no requirements means no violations
        return true;
    }

    const { placement } = requirements;
    if (!placement) {
        // no placement from requirements means no violations
        return true;
    }

    let
        allowedPassed = false,
        forbiddenPassed = false;

    if (placement.allowed) {
        const result = _.some(placement.allowed, (allowedPattern :any) => {
            const rowPattern = `^${allowedPattern.row}$`;
            const columnPattern = `^${allowedPattern.column}$`;

            return currentPlacement.column.match(new RegExp(columnPattern)) !== null
                && currentPlacement.row.match(new RegExp(rowPattern)) !== null;
        });

        if (result) {
            allowedPassed = true;
        }
    } else {
        allowedPassed = true;
    }

    if (placement.forbidden) {
        const result = _.some(placement.forbidden, (forbiddenPattern :any) => {
            const rowPattern = `^${forbiddenPattern.row}$`;
            const columnPattern = `^${forbiddenPattern.column}$`;

            return currentPlacement.column.match(new RegExp(columnPattern)) !== null
                && currentPlacement.row.match(new RegExp(rowPattern)) !== null;
        });

        if (!result) {
            forbiddenPassed = true;
        }
    } else {
        forbiddenPassed = true;
    }

    return allowedPassed && forbiddenPassed;
};
